import { newToolFilterOAuthMcp } from "../oauth.ts";

export const clarifyMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://app.clarify.ai/images/apple-touch-icon.png",
  url: "https://api.clarify.ai/mcp",
  label: "Clarify",
});
